module.exports = __webpack_public_path__ + "static/media/3.6c83bf01.png";